import { useRef, useState } from "react";

import { EmptyIcon } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/icons/EmptyIcon";
import { FilledIcon } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/icons/FilledIcon";
import { useIsMobileScreen } from "~/hooks/ui/useIsMobileScreen";

import * as styles from "../../Modals.css";

const ratingLabels = [
  "",
  "Awful, not at all what I expected",
  "Awful / Poor",
  "Poor, very disappointed",
  "Poor / Average",
  "Average, could be better",
  "Average / Good",
  "Good, what I expected",
  "Good / Amazing",
  "Amazing, exceeded expectations!",
];

export const RateModalStars = ({
  handleContinue,
  productReviewScore,
  setProductReviewText,
  setProductReviewScore,
}: {
  productReviewScore: number;
  handleContinue?: () => void;
  setProductReviewText?: (value: string) => void;
  setProductReviewScore: (value: number) => void;
}) => {
  const precision = 0.5;
  const ratingContainerRef = useRef(null);
  const isMobileScreen = useIsMobileScreen();
  const [hoverActiveStar, setHoverActiveStar] = useState(productReviewScore);

  const calculateRating = (e: { clientX: number }) => {
    if (ratingContainerRef.current === null) return 0;

    const { width, left } = (ratingContainerRef.current as Element).getBoundingClientRect();
    const percent = (e.clientX - left - 5) / width;
    const numberInStars = percent * 5;
    const nearestNumber = Math.round((numberInStars + precision / 2) / precision) * precision;

    if (nearestNumber < 1) return 0;

    return Number(nearestNumber.toFixed(precision.toString().split(".")[1]?.length || 0));
  };

  const getRatingText = (rating: number) => {
    if (rating === 0) return "Select Rating";

    return ratingLabels[rating * 2 - 1];
  };

  return (
    <>
      <p className={styles.ratingLabel}>{getRatingText(hoverActiveStar)}</p>
      <div
        className={styles.ratingContainer}
        ref={ratingContainerRef}
        onClick={(e) => {
          if (!setProductReviewText && handleContinue) {
            handleContinue();
          }
          setProductReviewScore(calculateRating(e));
        }}
        onMouseMove={(e) => {
          setHoverActiveStar(calculateRating(e));
        }}
        onMouseLeave={() => {
          setHoverActiveStar(productReviewScore);
        }}
      >
        {[...new Array(5)].map((_, index) => {
          const showEmptyIcon = hoverActiveStar === -1 || hoverActiveStar < index + 1;
          const isActiveRating = hoverActiveStar !== 1;
          const isRatingWithPrecision = hoverActiveStar % 1 !== 0;
          const isRatingEqualToIndex = Math.ceil(hoverActiveStar) === index + 1;
          const showRatingWithPrecision =
            isActiveRating && isRatingWithPrecision && isRatingEqualToIndex;

          return (
            <div key={index} className={styles.ratingSelector}>
              <div
                style={{
                  width: showRatingWithPrecision ? `${(hoverActiveStar % 1) * 100}%` : "0%",
                  overflow: "hidden",
                  position: "absolute",
                }}
              >
                <FilledIcon width={!isMobileScreen ? 53 : 38} height={!isMobileScreen ? 51 : 36} />
              </div>
              <div>
                {showEmptyIcon ? (
                  <EmptyIcon width={!isMobileScreen ? 53 : 38} height={!isMobileScreen ? 51 : 36} />
                ) : (
                  <FilledIcon
                    width={!isMobileScreen ? 53 : 38}
                    height={!isMobileScreen ? 51 : 36}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
